

export class VlanSede {
idVlanSede: number;;
nombreVlanSede:string;
idCompania: number;;
idCiudad: number;;
idSede: number;
ipInicialRango:string;
idAmbiente:number;
indHabilitado:boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vlan-sede-dto.ts